<template>
  <span v-if="typeof iprUrl !== 'undefined'">
    <li v-if="show==='pre'" class="accordionMenu_item accordionMenu_link">
      <a class="accordionMenu_title" :href="iprUrl + '/pages/regions.aspx'">Location</a>
    </li>
    <li v-if="show==='post'" class="accordionMenu_item accordionMenu_link">
      <a class="accordionMenu_title" :href="iprUrl + '/reports/locissues.asp?id=10'">Data quality</a>
    </li>
    <li v-if="show==='post'" class="accordionMenu_item accordionMenu_link">
      <a class="accordionMenu_title" :href="iprUrl + '/micadforms/dashboard/dashboardselect.asp'">Dashboard compare</a>
    </li>
    <li v-if="show==='post'" class="accordionMenu_item accordionMenu_link">
      <a class="accordionMenu_title" :href="iprUrl + '/defaultAsbestos.asp'">Asbestos statistics</a>
    </li>
  </span>
</template>

<script>
import appConfig from '@/config'

export default {
    name: "SideNavExtraLinks",
    props: {
      show: String,
    },
    data(){
      return {
        iprUrl: appConfig.IPR_BASE_URL
      }
    }
  }
</script>
